import { fields } from './constants';
import { defaultCampaignName } from './utils';
import { Campaign } from '@local-types/campaign';
import { ArrayToTuple, FieldStructure } from '@local-types/general';
import {
  generateSchemaFromFields,
  getFormDefaultValues,
} from '@helpers/form';

export const defaultValues = () => {
  const defaultVals = getFormDefaultValues(fields);
  // set campaign default name explictly here as it needs real-time update
  defaultVals[fields.name.path] = defaultCampaignName();
  return defaultVals;
};

const objectiveGoalsRelatedPaths = [
  fields.objectiveGoalEvent.path,
  fields.objectiveGoalType.path,
  fields.objectiveGoalValueCost.path,
  fields.objectiveGoalValueMultiplier.path,
];

export const validationSchema = ({
  campaign,
  objectiveGoalsAllowed,
  relatedFields = fields,
}: {
  campaign?: Campaign;
  objectiveGoalsAllowed: boolean;
  relatedFields?: Record<string, FieldStructure>;
}) => {
  return generateSchemaFromFields(relatedFields, ({ path }) =>
    objectiveGoalsAllowed ||
    !objectiveGoalsRelatedPaths.includes(
      path as ArrayToTuple<typeof objectiveGoalsRelatedPaths>
    )
      ? { campaign }
      : {}
  );
};
